import { DoorOpen } from 'lucide-react';
import type { BuildingUnitEntry } from '../../types';
import { formatUnitFloorLabel, groupBuildingUnitsByFloor } from '../../utils/buildingUnitsReview';

interface BuildingUnitsDetailSectionProps {
  units: BuildingUnitEntry[];
}

export function BuildingUnitsDetailSection({ units }: BuildingUnitsDetailSectionProps) {
  if (units.length === 0) return null;

  const floors = groupBuildingUnitsByFloor(units);

  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 p-4">
      <div className="flex items-center justify-between gap-2 mb-3">
        <div className="flex items-center gap-2">
          <DoorOpen size={16} className="text-gray-500" />
          <h3 className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">
            Units & rooms
          </h3>
        </div>
        <span className="text-xs text-gray-500 dark:text-gray-400">
          {units.length} unit{units.length !== 1 ? 's' : ''}
        </span>
      </div>
      <div className="space-y-3">
        {floors.map(({ floor, labels }) => (
          <div key={floor}>
            <p className="text-xs font-medium text-gray-500 dark:text-neutral-400 mb-1.5">
              {formatUnitFloorLabel(floor)}
            </p>
            <div className="flex flex-wrap gap-1.5">
              {labels.map((label) => (
                <span
                  key={`${floor}-${label}`}
                  className="inline-flex items-center px-2.5 py-1 rounded-lg text-sm font-medium bg-gray-100 dark:bg-neutral-700 text-gray-800 dark:text-neutral-200"
                >
                  {label}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
